import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Div = styled.div`
    display: flex;
    justify-content: ${({ center, justifyContent }) =>
        justifyContent ? justifyContent : center ? 'center' : 'flex-end'};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    position: ${({ position }) => (position ? position : 'sticky')};
    flex-direction: ${({ showCancel }) => (showCancel ? 'row' : '')};
    bottom: 0;
`;

export const WarningModalDiv = styled.div`
    width: ${(props) =>
        props.modalContentWidth ? props.modalContentWidth : '430px'};
    height: ${(props) =>
        props.modalContentHeight ? props.modalContentHeight : '200px'};
    ${media.mobileDevice`
        width: 310px;
        height: max-content;
    `};
    @media screen and (max-device-width: 375px) {
        width: auto;
    }
`;

export const Text = styled.div`
    height: ${({ webHeight }) => (webHeight ? webHeight : '155px')};
    font: ${({ font }) => (font ? font : '16px Avenir Next World')};
    font-family: 'AvenirNextWorld Regular';
    color: ${({ color }) => (color ? color : '#000000')};
    letter-spacing: -0.11px;
    opacity: 1;
    padding-top: 12px;
    padding-left: ${({ paddingLeft }) => paddingLeft};
    line-height: ${({ lineHeight }) => lineHeight};
    flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : '0')};
    ${media.mobileDevice` 
        height: ${({ height }) => (height ? height : '190px')};
        font: ${({ font }) => (font ? font : '15px Avenir Next World')};;
        font-family:'AvenirNextWorld Regular';
        margin-bottom: ${({ mbMarginBottom }) => (mbMarginBottom ? mbMarginBottom : '0')};
    `};
`;
